<template>
  <div class="container top-level-div">
    <button class="mylisting-button dark-button" @click="createContent()">Create Content</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  methods: {
    createContent() {
      axios.post('/api/contentpages/', {
        // poster: 1069, // This is Hayley's admin account
        poster: 4,
        slug: 'what-is-global-health',
        title: 'What is Global Health?',
        // // agency_owner: this.$store.getters.agencyName,
        agency_owner: 'ThriveHire',
        // // agency: this.$store.getters.agencyID,
        agency: 4,
      })
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/CreateContent.vue